import { OperationSpec, OperationType } from '@sqior/js/operation';

export const DefaultLocationPath = 'default-location';
export const AvailableDefaultLocationsPath = 'available-default-locations';

export function SetDefaultLocation(key: string): OperationSpec<string> {
  return { type: OperationType.Add, path: DefaultLocationPath, data: key };
}
